import i18n from '@/i18n'
import { TimeRanges, CustomTimeRangeTypes } from '@colven/common-domain-lib/lib'

/**
 * Constantes que definen el tipo de diálogo
 */
export const DialogType = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'thumb_up',
  INFO: 'info',
  QUESTION: 'contact_support'
}

/**
 * Constantes que definen el tipo de snackbar
 */
export const SnackbarStyle = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'done',
  INFO: 'info'
}

/**
 * Tema por defecto
 */
export const ColvenTheme = {
  light: {
    primary: '#0694de',
    secondary: '#1976d2',
    accent: '#69CAFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    'icon-primary': '#0694de',
    'icon-secondary': '#1976d2'
  },
  dark: {
    primary: '#616161',
    secondary: '#455a64',
    accent: '#768C97',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    'icon-primary': '#616161',
    'icon-secondary': '#455a64'
  }
}

/**
 * Estas constantes definen el tipo de restablecimiento de la contraseña:
 * 1- Restablecimiento por parte del usuario (RESET);
 * 2- Restablecimiento por fecha de expiración de la contraseña (EXPIRATION);
 * 3- Restablecimiento en el siguiente inicio de sesión (NEXT_LOGIN).
 */
export const ResetPasswordType = {
  USER_RESET: 'RESET',
  EXPIRATION: 'EXPIRATION_RESET',
  NEXT_LOGIN: 'NEXT_LOGIN_RESET'
}

/**
 * Constantes para la configuración del componente mapa
 */
export const MapConfig = {
  height: 600,
  mapTiles: [
    { url: 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga', name: 'Google Road', icon: 'map' },
    { url: 'https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}&s=Ga', name: 'Google Satellite', icon: 'satellite', base: true },
    { url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', name: 'Wikimedia', icon: 'map' },
    // { url: 'https://api.maptiler.com/maps/voyager/{z}/{x}/{y}.png?key=CIekAclgCLfQy03ebnmC', name: 'Map', icon: 'map', base: true },
    { url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg', name: 'ArcGIS Satellite', icon: 'satellite' },
    { url: 'https://api.maptiler.com/maps/topo/{z}/{x}/{y}.png?key=CIekAclgCLfQy03ebnmC', name: 'Topographic', icon: 'terrain' }
  ]
}

/**
 * Se definen los tipos de filtros que son usados en el componente tabla
 */
export const FilterType = {
  textField: 'TEXT_FIELD',
  select: 'SELECT',
  multiSelect: 'MULTISELECT'
}

/**
 * Tipos de datos para cada columna
 */
export const DataType = {
  string: 'STRING',
  number: 'NUMBER',
  boolean: 'BOOLEAN',
  options: 'OPTIONS'
}
/**
 * Tipos de gráficos (usados en el componente genérico)
 */
export const ChartTypes = {
  BAR: 'bar',
  HORIZONTAL_BAR: 'horizontalBar',
  LINE: 'line',
  PIE: 'pie',
  DOUGHNUT: 'doughnut',
  COMPOSITE: 'composite'
}

/**
 * Tipo de Dialog para las acciones en el componente tabla genérico
 */
export const TableDialogType = {
  MODIFY_COLUMNS: 'MODIFY_COLUMNS',
  CHARTS: 'CHARTS',
  MAPS: 'MAPS'
}

/**
 * Tipo de Serie a insertar en un mapa
 */
export const SerieType = {
  LINE: 'LINE',
  POLYGON: 'POLYGON',
  MARKERS: 'MARKERS',
  LINE_MARKER: 'LINE_MARKER',
  POLYGON_MARKER: 'POLYGON_MARKER'
}

/**
 * Constantes que definen los tipos de notificaciones
 * TO DO: arreglar el common-domain (quitar las dependencias de nestjs)
 */
export const NotificationType = {
  REPORT: {
    name: 'REPORT',
    icon: 'fa-list-alt',
    color: '#42A5F5'
  }
}

/**
 * Constantes para la imagen del ABM de Things
 *
 * TO DO: agregar los íconos faltantes
 * El default es el de tractores
 */
export const TypeIcons = {
  TRUCK: 'TRUCK.svg',
  HARVESTER: 'HARVESTER.svg',
  TRACTOR: 'TRACTOR.svg',
  // STOREROOM: 'STOREROOM.svg',
  // SPRINKLER: 'SPRINKLER.svg',
  TRAILER: 'TRAILER.svg',
  LOADER: 'FRONT_LOADER.svg', // TO DO: cambiar
  BACKHOE_LOADER: 'FRONT_LOADER.svg', // TO DO: cambiar
  BULLDOZER: 'BULLDOZER.svg',
  EXCAVATOR_CAT_320_D: 'EXCAVATOR.svg',
  // CART: 'CART.svg',
  FRONT_LOADER: 'FRONT_LOADER.svg',
  GRADER: 'GRADER.svg',
  // ENGANCHABLE: 'ENGANCHABLE.svg',
  // CRANE: 'CRANE.svg',
  QUAD: 'QUAD.svg',
  // SOLAR_EQUIPMENT: 'SOLAR_EQUIPMENT.svg',
  // CANE_EQUIPMENT: 'CANE_EQUIPMENT.svg',
  VEHICLE: 'VEHICLE.svg',
  // HARROW_2832: 'HARROW_2832.svg',
  // HARROW_3232: 'HARROW_3232.svg',
  // HARROW_2032: 'HARROW_2032.svg',
  // HARROW_COMBINED: 'HARROW_COMBINED.svg',
  PLANTER: 'HARVESTER.svg', // TO DO: cambiar
  HARVEST_TRACTOR: 'TRACTOR.svg',
  FARM_TRACTOR: 'TRACTOR.svg',
  // CANE_TRANSPORT: 'CANE_TRANSPORT.svg',
  // OTHER_IMPLEMENTS: 'OTHER_IMPLEMENTS.svg',
  // FERTILIZER: 'FERTILIZER.svg',
  LOGISTIC_TRUCK: 'TRUCK.svg',
  // UNDERGROWTH_CONTROL: 'UNDERGROWTH_CONTROL.svg',
  // PLAGUE_CONTROL: 'PLAGUE_CONTROL.svg',
  LOGISTIC_VEHICLE: 'VEHICLE.svg',
  // FARM_OTHER_ACTIVITIES: 'FARM_OTHER_ACTIVITIES.svg'

  // ---------------------------------------------------
  // -------------------- DEFAULT ----------------------
  // ---------------------------------------------------
  DEFAULT: 'TRACTOR.svg'
}

/**
 * Expresiones regulares para validar campos
 */
export const REGEX = {
  hexadecimal: /^[0-9a-fA-F]+$/,
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  phone: /^[0-9*#+-]*$/,
  number: /^[0-9]*$/,
  numberWithDecimal: /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/,
  letters: /^[A-Za-z]+$/,
  ip: /^(?=.*[^.]$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?){4}$/,
  dni: /^[0-9]{8,8}$/,
  imageType: /(.+\.png)$/i
}

/**
 * ID del estado "activa" de una línea
 *
 * TO DO: implementar de otra forma
 */
export const LINE_ACTIVE_STATE = '1'
export const CALL_CENTER_EMAIL = 'usuarios@gestya.com'
/**
 * Constantes para el bus de eventos
 */
export const EventHub = {
  COMMIT_LINE: 'commitLine',
  COMMIT_SCORING_CONFIGURATION: 'COMMIT_SCORING_CONFIGURATION',
  COMMIT_RUS_CONFIGURATION: 'COMMIT_RUS_CONFIGURATION',
  COMMIT_EVENT_CONFIGURATION: 'COMMIT_EVENT_CONFIGURATION',
  COMMIT_EDIT_EVENT: 'COMMIT_EDIT_EVENT',
  COMMIT_FARM: 'COMMIT_FARM',
  COMMIT_ECOLOGICAL_UNIT: 'COMMIT_ECOLOGICAL_UNIT',
  COMMIT_EVENT_TYPE: 'COMMIT_EVENT_TYPE',
  COMMIT_EVENT: 'COMMIT_EVENT',
  UPDATE_EVENT: 'UPDATE_EVENT',
  COMMIT_STATE_TYPE: 'COMMIT_STATE_TYPE',
  COMMIT_SECTOR: 'COMMIT_SECTOR',
  COMMIT_USER_PROFILE: 'COMMIT_USER_PROFILE',
  COMMIT_GPS: 'COMMIT_GPS',
  COMMIT_GROUP: 'COMMIT_GROUP',
  COMMIT_FLEET: 'COMMIT_FLEET',
  COMMIT_CATEGORY: 'COMMIT_CATEGORY',
  COMMIT_ALERT_EVENT: 'COMMIT_ALERT_EVENT',
  COMMIT_WORK_FRONT: 'COMMIT_WORK_FRONT',
  COMMIT_HARVEST: 'COMMIT_HARVEST',
  UPDATE_HARVEST: 'UPDATE_HARVEST',
}

/**
 * Modelo para el componente selector
 */
export const SelectorModel = {
  title: i18n.t('selector.selector'),
  showClose: true,
  filters: [],
  selects: [],
  disableSaveButton: true,
  saveButtonText: i18n.t('selector.getReport'),
  showDateAndTimeSelector: true,
  selectedDateAndTimeRange: TimeRanges.LAST_HOUR,
  selectedDateAndTimeRangeCustomType: CustomTimeRangeTypes.DATE,
  sinceDate: null,
  sinceTime: null,
  toDate: null,
  toTime: null,
  customDateTimeValidForm: false,
  autoReport: false,
  autoReportMinutes: 10,
  showAutoReport: false,
  showCustomInputComponent: false,
  customInputComponent: {
    name: '',
    content: {
      _uid: '9d1zXJn184',
      component: '',
      headline: ''
    },
    model: {}
  }
}
// values para el selector de valores del dialog del ABM de metas
export const stateTargetsValues = [
  { id: '1', name: "1" },
  { id: '2', name: "2" },
  { id: '3', name: "3" },
  { id: '4', name: "4" },
  { id: '5', name: "5" },
  { id: '6', name: "6" },
  { id: '7', name: "7" },
  { id: '8', name: "8" },
  { id: '9', name: "9" },
  { id: '10', name: "10" },
  { id: '11', name: "11" },
  { id: '12', name: "12" },
  { id: '13', name: "13" },
  { id: '14', name: "14" },
  { id: '15', name: "15" },
  { id: '16', name: "16" },
  { id: '17', name: "17" },
  { id: '18', name: "18" },
  { id: '19', name: "19" },
  { id: '20', name: "20" },
  { id: '21', name: "21" },
  { id: '22', name: "22" },
  { id: '23', name: "23" },
  { id: '24', name: "24" },
]


export const LEGAL_PERSON_TYPES_MASKS = {
  CUIT: '##-########-#',
  CNPJ: '##.###.###/####-##',
  CPF: '###.###.###-##'
}

export const NOTIFICATION_FIELDS_LIST = [
  "thingName",
  "speed",
  "direction",
  "eventName",
  "trackTimestamp",
  "latitude",
  "longitude",
  "enterpriseId",
  "timestamp",
  "address"
]

export const INTERNATIONALIZATION_UNITS = [
  { name: "simela", translate: 'internationalization.simela' },
  { name: "imperial", translate: 'internationalization.imperial' },
  { name: "latin", translate: 'internationalization.latin' }
]
export const INTERNATIONALIZATION_DATE = [
  "24hs",
  "12hs (AM/PM)"
]
export const INTERNATIONALIZATION_DATE_MASK = [
  "dd/mm/yyyy",
  "mm/dd/yyyy"
]

export const DEFAULT_TIMEZONE = -3;
export const STATES_KEYS_FOR_OBJETIVES_ABM_SELECTOR = ['IDLE', 'MANEUVERING', 'PARADA', 'FALTA_VACIO', 'WORKING']
export const TIME_ZONES_AND_COUNTRIES = [
  {
    zone: 'UTC-8',
    timeZone: -8,
    country: '(UTC-8) Estados Unidos',
    id: 0
  },
  {
    zone: 'UTC-8',
    timeZone: -8,
    country: '(UTC-8) Islas Pitcairn',
    id: 1
  },
  {
    zone: 'UTC-7',
    timeZone: -7,
    country: '(UTC-7) Canadá',
    id: 2
  },
  {
    zone: 'UTC-7',
    timeZone: -7,
    country: '(UTC-7) Estados Unidos',
    id: 3
  },
  {
    zone: 'UTC-7',
    timeZone: -7,
    country: '(UTC-7) México',
    id: 4
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Belice',
    id: 5
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Canadá',
    id: 6
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Chile',
    id: 7
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Costa Rica',
    id: 8
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) El Salvador',
    id: 9
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Estados Unidos',
    id: 10
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Guatemala',
    id: 11
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Honduras',
    id: 12
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) México',
    id: 13
  },
  {
    zone: 'UTC-6',
    timeZone: -6,
    country: '(UTC-6) Nicaragua',
    id: 14
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Brasil',
    id: 15
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Canadá',
    id: 16
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Colombia',
    id: 17
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Ecuador',
    id: 18
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Estados Unidos',
    id: 19
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Islas Caimán',
    id: 20
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Jamaica',
    id: 21
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) México',
    id: 22
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Panamá',
    id: 23
  },
  {
    zone: 'UTC-5',
    timeZone: -5,
    country: '(UTC-5) Perú',
    id: 24
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Anguila',
    id: 25
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Antigua y Barbuda',
    id: 26
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Aruba',
    id: 27
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Bahamas',
    id: 28
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Barbados',
    id: 29
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Bolivia',
    id: 30
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Brasil',
    id: 31
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Canadá',
    id: 32
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Caribe',
    id: 33
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Chile',
    id: 34
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Cuba',
    id: 35
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Curazao',
    id: 36
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Dominica',
    id: 37
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Estados Unidos',
    id: 38
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Granada',
    id: 39
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Guadalupe',
    id: 40
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Guyana',
    id: 41
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Haití',
    id: 42
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Islas Turcas y Caicos',
    id: 43
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Islas Vírgenes',
    id: 44
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Martinica',
    id: 45
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Montserrat',
    id: 46
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Paraguay',
    id: 47
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Puerto Rico',
    id: 48
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) República Dominicana',
    id: 49
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) San Cristóbal y Nieves',
    id: 50
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) San Vicente y las Granadinas',
    id: 51
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Santa Lucía',
    id: 52
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Sint Maarten',
    id: 53
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Trinidad y Tobago',
    id: 54
  },
  {
    zone: 'UTC-4',
    timeZone: -4,
    country: '(UTC-4) Venezuela',
    id: 55
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Argentina',
    id: 56
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Bermudas',
    id: 57
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Brasil',
    id: 58
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Canadá',
    id: 59
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Guayana Francesa',
    id: 60
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Islas Malvinas',
    id: 61
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Surinam',
    id: 62
  },
  {
    zone: 'UTC-3',
    timeZone: -3,
    country: '(UTC-3) Uruguay',
    id: 63
  },
  {
    zone: 'UTC-2.,5',
    timeZone: -2,
    country: '(UTC-2.,5) Canadá',
    id: 64
  },
  {
    zone: 'UTC-2',
    timeZone: -2,
    country: '(UTC-2) Groenlandia',
    id: 65
  },
  {
    zone: 'UTC-2',
    timeZone: -2,
    country: '(UTC-2) Islas Georgias del Sur y Sandwich del Sur',
    id: 66
  },
  {
    zone: 'UTC-2',
    timeZone: -2,
    country: '(UTC-2) San Pedro y Miquelón',
    id: 67
  },
  {
    zone: 'UTC-11',
    timeZone: -11,
    country: '(UTC-11) Niue',
    id: 68
  },
  {
    zone: 'UTC-11',
    timeZone: -11,
    country: '(UTC-11) Samoa Americana',
    id: 69
  },
  {
    zone: 'UTC-10',
    timeZone: -10,
    country: '(UTC-10) Estados Unidos',
    id: 70
  },
  {
    zone: 'UTC-10',
    timeZone: -10,
    country: '(UTC-10) Islas Cook',
    id: 71
  },
  {
    zone: 'UTC-10',
    timeZone: -10,
    country: '(UTC-10) Islas ultramarinas de Estados Unidos',
    id: 72
  },
  {
    zone: 'UTC-10',
    timeZone: -10,
    country: '(UTC-10) Polinesia Francesa',
    id: 73
  },
  {
    zone: 'UTC-1',
    timeZone: -1,
    country: '(UTC-1) Cabo Verde',
    id: 74
  },
  {
    zone: 'UTC+9.5',
    timeZone: 9.5,
    country: '(UTC+9.5) Australia',
    id: 75
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Corea del Norte',
    id: 76
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Corea del Sur',
    id: 77
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Indonesia',
    id: 78
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Japón',
    id: 79
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Palaos',
    id: 80
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Rusia',
    id: 81
  },
  {
    zone: 'UTC+9',
    timeZone: 9,
    country: '(UTC+9) Timor Oriental',
    id: 82
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Australia',
    id: 83
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Brunéi',
    id: 84
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) China',
    id: 85
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Filipinas',
    id: 86
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Hong Kong',
    id: 87
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Indonesia',
    id: 88
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Macau',
    id: 89
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Malasia',
    id: 90
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Mongolia',
    id: 91
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Rusia',
    id: 92
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Singapur',
    id: 93
  },
  {
    zone: 'UTC+8',
    timeZone: 8,
    country: '(UTC+8) Taiwán',
    id: 94
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Camboya',
    id: 95
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Indonesia',
    id: 96
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Isla de Navidad',
    id: 97
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Laos',
    id: 98
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Rusia',
    id: 99
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Tailandia',
    id: 100
  },
  {
    zone: 'UTC+7',
    timeZone: 7,
    country: '(UTC+7) Vietnam',
    id: 101
  },
  {
    zone: 'UTC+6.5',
    timeZone: 6.5,
    country: '(UTC+6.5) Islas Cocos',
    id: 102
  },
  {
    zone: 'UTC+6.5',
    timeZone: 6.5,
    country: '(UTC+6.5) Myanmar',
    id: 103
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Antártida',
    id: 104
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Bangladesh',
    id: 105
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Bután',
    id: 106
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) China',
    id: 107
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Kazajistán',
    id: 108
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Kirguistán',
    id: 109
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Rusia',
    id: 110
  },
  {
    zone: 'UTC+6',
    timeZone: 6,
    country: '(UTC+6) Territorio Británico del Océano Índico',
    id: 111
  },
  {
    zone: 'UTC+5.75',
    timeZone: 5.75,
    country: '(UTC+5.75) Nepal',
    id: 112
  },
  {
    zone: 'UTC+5.5',
    timeZone: 5.5,
    country: '(UTC+5.5) India',
    id: 113
  },
  {
    zone: 'UTC+5.5',
    timeZone: 5.5,
    country: '(UTC+5.5) Sri Lanka',
    id: 114
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Islas Heard y McDonald',
    id: 115
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Maldivas',
    id: 116
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Pakistán',
    id: 117
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Rusia',
    id: 118
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Tayikistán',
    id: 119
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Turkmenistán',
    id: 120
  },
  {
    zone: 'UTC+5',
    timeZone: 5,
    country: '(UTC+5) Uzbekistán',
    id: 121
  },
  {
    zone: 'UTC+4.5',
    timeZone: 4.5,
    country: '(UTC+4.5) Afganistán',
    id: 122
  },
  {
    zone: 'UTC+4.5',
    timeZone: 4.5,
    country: '(UTC+4.5) Irán',
    id: 123
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Armenia',
    id: 124
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Azerbaiyán',
    id: 125
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Emiratos Árabes Unidos',
    id: 126
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Georgia',
    id: 127
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Mauricio',
    id: 128
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Omán',
    id: 129
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Reunión',
    id: 130
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Rusia',
    id: 131
  },
  {
    zone: 'UTC+4',
    timeZone: 4,
    country: '(UTC+4) Seychelles',
    id: 132
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Aland',
    id: 133
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Arabia Saudita',
    id: 134
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Bahréin',
    id: 135
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Bielorrusia',
    id: 136
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Bulgaria',
    id: 137
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Chipre',
    id: 138
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Comoras',
    id: 139
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Eritrea',
    id: 140
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Estonia',
    id: 141
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Etiopía',
    id: 142
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Finlandia',
    id: 143
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Grecia',
    id: 144
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Iraq',
    id: 145
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Israel',
    id: 146
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Jordania',
    id: 147
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Kenia',
    id: 148
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Kuwait',
    id: 149
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Letonia',
    id: 150
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Líbano',
    id: 151
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Lituania',
    id: 152
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Madagascar',
    id: 153
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Mayotte',
    id: 154
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Moldova',
    id: 155
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Palestina',
    id: 156
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Qatar',
    id: 157
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Rumania',
    id: 158
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Rusia',
    id: 159
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Siria',
    id: 160
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Somalia',
    id: 161
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Tanzania',
    id: 162
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Turquía',
    id: 163
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Ucrania',
    id: 164
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Uganda',
    id: 165
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Yemen',
    id: 166
  },
  {
    zone: 'UTC+3',
    timeZone: 3,
    country: '(UTC+3) Yibuti',
    id: 167
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Albania',
    id: 168
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Alemania',
    id: 169
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Andorra',
    id: 170
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Austria',
    id: 171
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Bélgica',
    id: 172
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Bosnia y Herzegovina',
    id: 173
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Botsuana',
    id: 174
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Burundi',
    id: 175
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Ciudad del Vaticano',
    id: 176
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Croacia',
    id: 177
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Dinamarca',
    id: 178
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Egipto',
    id: 179
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Eslovaquia',
    id: 180
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Eslovenia',
    id: 181
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) España',
    id: 182
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Francia',
    id: 183
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Gibraltar',
    id: 184
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Hungría',
    id: 185
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Isla Bouvet',
    id: 186
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Italia',
    id: 187
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Lesoto',
    id: 188
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Libia',
    id: 189
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Liechtenstein',
    id: 190
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Luxemburgo',
    id: 191
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Macedonia',
    id: 192
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Malawi',
    id: 193
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Malta',
    id: 194
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Mónaco',
    id: 195
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Montenegro',
    id: 196
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Mozambique',
    id: 197
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Namibia',
    id: 198
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Noruega',
    id: 199
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Países Bajos',
    id: 200
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Polonia',
    id: 201
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) República Checa',
    id: 202
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) República',
    id: 203
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Ruanda',
    id: 204
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Rusia',
    id: 205
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) San Marino',
    id: 206
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Serbia',
    id: 207
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Suazilandia',
    id: 208
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Sudáfrica',
    id: 209
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Sudán',
    id: 210
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Suecia',
    id: 211
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Suiza',
    id: 212
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Svalbard y Jan Mayen',
    id: 213
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Zambia',
    id: 214
  },
  {
    zone: 'UTC+2',
    timeZone: 2,
    country: '(UTC+2) Zimbabue',
    id: 215
  },
  {
    zone: 'UTC+13',
    timeZone: 13,
    country: '(UTC+13) Samoa ',
    id: 216
  },
  {
    zone: 'UTC+13',
    timeZone: 13,
    country: '(UTC+13) Tokelau',
    id: 217
  },
  {
    zone: 'UTC+13',
    timeZone: 13,
    country: '(UTC+13) Tonga',
    id: 218
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Fiyi ',
    id: 219
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Islas Marshall',
    id: 220
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Kiribati',
    id: 221
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Nauru',
    id: 222
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Nueva Zelanda',
    id: 223
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Rusia',
    id: 224
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Tuvalu',
    id: 225
  },
  {
    zone: 'UTC+12',
    timeZone: 12,
    country: '(UTC+12) Wallis y Futuna',
    id: 226
  },
  {
    zone: 'UTC+11',
    timeZone: 11,
    country: '(UTC+11) Islas Salomón',
    id: 227
  },
  {
    zone: 'UTC+11',
    timeZone: 11,
    country: '(UTC+11) Micronesia',
    id: 228
  },
  {
    zone: 'UTC+11',
    timeZone: 11,
    country: '(UTC+11) Norfolk',
    id: 229
  },
  {
    zone: 'UTC+11',
    timeZone: 11,
    country: '(UTC+11) Nueva Caledonia',
    id: 230
  },
  {
    zone: 'UTC+11',
    timeZone: 11,
    country: '(UTC+11) Vanuatu',
    id: 231
  },
  {
    zone: 'UTC+10',
    timeZone: 10,
    country: '(UTC+10) Australia',
    id: 232
  },
  {
    zone: 'UTC+10',
    timeZone: 10,
    country: '(UTC+10) Guam',
    id: 233
  },
  {
    zone: 'UTC+10',
    timeZone: 10,
    country: '(UTC+10) Islas Marianas del Norte',
    id: 234
  },
  {
    zone: 'UTC+10',
    timeZone: 10,
    country: '(UTC+10) Papúa Nueva Guinea',
    id: 235
  },
  {
    zone: 'UTC+10',
    timeZone: 10,
    country: '(UTC+10) Rusia Vladivostok',
    id: 236
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Angola',
    id: 237
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Argelia',
    id: 238
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Benín',
    id: 239
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Camerún',
    id: 240
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Chad',
    id: 241
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) España',
    id: 242
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Gabón',
    id: 243
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Guernsey',
    id: 244
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Guinea Ecuatorial',
    id: 245
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Irlanda',
    id: 246
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Isla de Man',
    id: 247
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Islas Feroe',
    id: 248
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Jersey',
    id: 249
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Marruecos',
    id: 250
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Níger',
    id: 251
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Nigeria',
    id: 252
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Portugal',
    id: 253
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Reino Unido',
    id: 254
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) República Centroafricana',
    id: 255
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) República del Congo',
    id: 256
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) República Democrática del Congo Kinshasa',
    id: 257
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Sahara Occidental',
    id: 258
  },
  {
    zone: 'UTC+1',
    timeZone: 1,
    country: '(UTC+1) Túnez ',
    id: 259
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Burkina Faso',
    id: 260
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Costa de Marfil',
    id: 261
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Gambia',
    id: 262
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Ghana',
    id: 263
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Guinea',
    id: 264
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Guinea Bissau',
    id: 265
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Islandia',
    id: 266
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Liberia',
    id: 267
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Malí',
    id: 268
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Mauritania',
    id: 269
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Portugal',
    id: 270
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Santa Helena',
    id: 271
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Santo Tomé y Príncipe',
    id: 272
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Senegal',
    id: 273
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Sierra Leona',
    id: 274
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Territorios Australes Franceses',
    id: 275
  },
  {
    zone: 'UTC+0',
    timeZone: 0,
    country: '(UTC+0) Togo',
    id: 276
  }
]

export const CALIBRATOR_MODELS ={
  P: "P",         //Panel
  LH: "L-H",      //NM444
  B: "B",          //NM344
  TK: "TK"      //NM257
}

export const DEFAULT_SPEED_VALUE = 80;

export const NAVBAR_PRIVILEGES_KEYS = {
  "backoffice.trackDisorder": { key: 'TRACK_DISORDER', i18nKey: 'trackDisorder.name', name: "", routeName: 'trackDisorder' },
  "backoffice.trackStatus": { key: 'TRACK_STATUS', i18nKey: 'trackStatus.name', name: "", routeName: 'trackStatus' },
  "backoffice.pimsLogs": { key: 'PIMS_LOGS', i18nKey: 'pimsLogs.name', name: "", routeName: 'pimsLogs' },
  "backoffice.forward": { key: 'FORWARD', i18nKey: 'forward.name', name: "", routeName: 'forward' }
}

/**
 * Países habilitados para asignar a un equipo (tag de país por LGPD).
 * El catálogo de países (colección countries) puede tener los nombres en inglés o en español,
 * por eso cada país se identifica por sus alias (en minúsculas y sin acentos)
 * y se muestra con el nombre en español
 */
export const THING_COUNTRIES = [
  { name: 'Argentina', aliases: ['argentina'] },
  { name: 'Chile', aliases: ['chile'] },
  { name: 'Perú', aliases: ['peru'] },
  { name: 'Brasil', aliases: ['brasil', 'brazil'] },
  { name: 'México', aliases: ['mexico'] },
  { name: 'Estados Unidos', aliases: ['estados unidos', 'united states', 'united states of america', 'usa', 'eeuu'] },
  { name: 'España', aliases: ['espana', 'spain'] },
  { name: 'Francia', aliases: ['francia', 'france'] },
  { name: 'Marruecos', aliases: ['marruecos', 'morocco'] },
  { name: 'Italia', aliases: ['italia', 'italy'] },
  { name: 'Alemania', aliases: ['alemania', 'germany'] },
  { name: 'Australia', aliases: ['australia'] },
  { name: 'Sudáfrica', aliases: ['sudafrica', 'south africa'] },
]
